<template>
  <div class="sales-dashboard page-wrapper">
    <div v-if="loading">
      <circle-loader :size="40"></circle-loader>
    </div>
    <div v-if="!loading">
      <div class="stats">
        <h3>Team Stats</h3>
        <h5>Buildings Created By {{ userStore.user.email }}</h5>
        <div class="row">
          <div class="col">
            <div v-if="buildingsCreated.dailyBuildings">
              <h6>Last 2 Weeks</h6>
              <recent-buildings-created-chart
                :data="buildingsCreated.dailyBuildings"
              ></recent-buildings-created-chart>
            </div>
          </div>
          <div class="col">
            <div v-if="buildingsCreated">
              <h6>All Time buildings</h6>
              <buildings-created-chart
                :data="buildingsCreated.monthlyBuildings"
              ></buildings-created-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { userStore } from '@/stores/userStore'
import moment from 'moment'
import CircleLoader from '@/components/CircleLoader.vue'
import BuildingsCreatedChart from '../components/BuildingsCreatedChart.vue'
import RecentBuildingsCreatedChart from '../components/RecentBuildingsCreatedChart.vue'

export default {
  name: 'SalesDashboarPage',
  components: {
    CircleLoader,
    BuildingsCreatedChart,
    RecentBuildingsCreatedChart,
  },
  inject: {
    userStore,
  },
  data: function () {
    return {
      loading: true,
      buildingsCreated: null,
    }
  },
  methods: {
    getBuildingStats() {
      return axios
        .get(
          '/services/buildings/stats/buildings-created?user=' +
            encodeURIComponent(this.userStore.user.email),
        )
        .then(response => {
          this.buildingsCreated = response.data
        })
        .catch(err => {
          console.log('err', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  computed: {},
  mounted() {
    this.getBuildingStats()
  },
}
</script>

<style lang="scss" scoped>
.notification {
  max-width: 800px;
}
</style>
